module.exports = __webpack_public_path__ + "assets/redpack-btn-bg-d35744c6.png";